import { Combo } from './combo.model';
import { Natureza } from './natureza.model';
import { Modalidade } from './modalidade.model';
import { Abrangencia } from './abrangencia.model';
import { Turma } from './turma-model';
import { Conteudo } from './conteudo-model';
import { CursoAreaTematica } from './curso-area-tematica';
import { CursoCriterioAvaliacao } from './curso-criterio-avaliacao';
import { CursoPublicoAlvo } from './curso-publico-alvo';
import { CursoInstrutor } from './curso-instrutor';
import { HomologacaoCurso } from './homologacao-curso.model';
import { Capacitadora } from './capacitadora.model';
import { AnexoCurso } from './anexo-curso.model';
import { BibliografiaCurso } from './bibliografia-curso.model';
import { AtividadeFuncaoExercida } from './atividade-funcao-exercida.model';

export class GerenciamentoCurso {
    public id: number;
    public bibliografia: string;
    public codigo_curso_capacitadora: string;
    public id_tipo_atividade: number;
    public id_modalidade: number;
    public id_abrangencia: number;
    public frequencia_minima: number;
    public carga_horaria: number;
    public titulo_traduzido: string;
    public titulo_original: string;
    public id_capacitadora: number;
    public id_situacao: number;
    public codigo: string;
    public situacao: Combo;
    public tipo_atividade: Natureza;
    public modalidade: Modalidade;
    public abrangencia: Abrangencia;
    public conteudo: Conteudo[];
    public curso_area_tematica: CursoAreaTematica[];
    public curso_criterio_avaliacao: CursoCriterioAvaliacao[];
    public curso_publico_alvo: CursoPublicoAlvo[];
    public curso_instrutor: CursoInstrutor[];
    public turma: Turma[];
    public homologacao_curso: HomologacaoCurso[];
    public capacitadora: Capacitadora;
    public observacao: any;
    public anexo_curso: AnexoCurso[];
    public bibliografia_curso: BibliografiaCurso[];
    public data_cadastro: Date;
    public data_envio: Date;
    public data_validade: Date;
    public atividade_funcao_exercida: AtividadeFuncaoExercida[];
}


// WEBPACK FOOTER //
// ./src/app/entity/gerenciamento-curso.model.ts